import { collection } from 'firebase/firestore'
import type { FirestoreDataConverter, WithFieldValue, DocumentData } from 'firebase/firestore'
import { db } from './firebase'
import type { EventAttendanceStatus, EventInterest, Friendship, SetPost } from '../types'

const eventInterestConverter: FirestoreDataConverter<EventInterest> = {
  toFirestore(data: WithFieldValue<EventInterest>): DocumentData {
    return data as DocumentData
  },
  fromFirestore(snap) {
    const data = snap.data()
    return {
      ...data,
      status: (data.status ?? 'interested') as EventAttendanceStatus,
    } as EventInterest
  },
}

export const eventInterestsCol = () =>
  collection(db, 'eventInterests').withConverter(eventInterestConverter)

const friendshipConverter: FirestoreDataConverter<Friendship> = {
  toFirestore(data: WithFieldValue<Friendship>): DocumentData {
    return data as DocumentData
  },
  fromFirestore(snap) {
    return { id: snap.id, ...snap.data() } as Friendship
  },
}

export const friendshipsCol = () =>
  collection(db, 'friendships').withConverter(friendshipConverter)

const setPostConverter: FirestoreDataConverter<SetPost> = {
  toFirestore(data: WithFieldValue<SetPost>): DocumentData {
    return data as DocumentData
  },
  fromFirestore(snap) {
    return { id: snap.id, ...snap.data() } as SetPost
  },
}

export const setPostsCol = () =>
  collection(db, 'setPosts').withConverter(setPostConverter)
